import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var _DialogDogHouseInfo = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.dog_treat, onClose: onClose, className: "" + IdStyles.ModalBackgroundInfo },
        React.createElement("div", { className: "flex flex--start flex--aligned w100 h100 dog-house-info__text" },
            React.createElement(TextLoca, { id: IdLoca.doghouse_info, className: IdStyles.TextBoldPrimary }))));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.DoghouseInfo)); },
}); };
export var DialogDogHouseInfo = connect(undefined, mapDispatch)(_DialogDogHouseInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DialogDogHouseInfo.tsx
// module id = 2817
// module chunks = 3